import { Button, Title, ButtonsGroup } from 'components/commons';
import trafficIcon from 'assets/svg/traffic-signal.svg';

const ExpiredProposalPage: React.FC = () => {
    const onOk = () => {
        window.location.href = '/pedido/';
    };

    return (
        <div className="message-box-container">
            <div className="inner">
                <div className="screen">
                    <div className="message-box">
                        <img
                            className="icon"
                            src={trafficIcon}
                        />

                        <Title>
                            sua proposta <br className="d-block d-sm-none" />
                            expirou!
                        </Title>

                        <p className="text">
                            Infelizmente, a nossa proposta tem uma validade e
                            agora o crédito que pré aprovamos não está mais
                            disponível.
                        </p>

                        <p className="text">
                            Mas você pode fazer um novo pedido{' '}
                            <br className="d-block d-sm-none" />à qualquer hora:
                        </p>
                    </div>

                    <ButtonsGroup align="left">
                        <Button label="pede biz, vai!" onClick={onOk} />
                    </ButtonsGroup>
                </div>
            </div>
        </div>
    );
};

export default ExpiredProposalPage;
